const regex = {
  cellPhoneRegex: /^[1-9]{2}\d{9}$/,
  phoneRegex: /^[1-9]{2}\d{9}$|^\d{3,4}[-]\d{7,8}$/,
  usernameRegex: /^[a-zA-Z]{1}$/,
};
const INTEGER_REGEXP = new RegExp("^-?\\d+$");
const DATE_TIME_REGEXP = new RegExp("^((((19|20)\\d{2})-(0?(1|[3-9])|1[012])-(0?[1-9]|[12]\\d|30))|(((19|20)\\d{2})-(0?[13578]|1[02])-31)|(((19|20)\\d{2})-0?2-(0?[1-9]|1\\d|2[0-8]))|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))-0?2-29))[\\s] *(20|21|22|23|[0-1]\\d):[0-5]\\d:[0-5]\\d$");
const DATE_REGEXP = new RegExp("^((((19|20)\\d{2})-(0?(1|[3-9])|1[012])-(0?[1-9]|[12]\\d|30))|(((19|20)\\d{2})-(0?[13578]|1[02])-31)|(((19|20)\\d{2})-0?2-(0?[1-9]|1\\d|2[0-8]))|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))-0?2-29))$");
const MILLISECOND = 1000;
export {regex};

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()
export function timediff ($begin_time,$end_time) {
  var $starttime = ''
  var $endtime = ''
  if ($begin_time < $end_time) {
    $starttime = $begin_time;
    $endtime = $end_time;
  } else {
    $starttime = $end_time;
    $endtime = $begin_time;
  }
  //计算天数
  var $timediff = $endtime - $starttime;
  // eslint-disable-next-line no-unused-vars
  var $days = parseInt($timediff / 86400);
  //计算小时数
  var $remain = $timediff % 86400;
  // eslint-disable-next-line no-unused-vars
  var $hours = parseInt($remain / 3600);
  //计算分钟数
/*  var $remain = $remain % 3600;
  var $mins = parseInt($remain / 60); */
  //计算秒数
  var $secs = $remain % 60;
  // $days=>天
  // $hours=>时
  // $mins=>分
  // $secs=>秒
  /*var  $res = [$days,$hours,$mins,$secs]*/
  return $secs
}

export function stampToDateTime(dateTimeStamp) {
  if (INTEGER_REGEXP.test(dateTimeStamp)) {
    let dateTime = new Date(dateTimeStamp * MILLISECOND);
    return formatDate(dateTime, "yyyy-MM-dd HH:mm:ss");
  }
  return "";
}

export function formatDate(date, fmt = 'yyyy-MM-dd HH:mm:ss') {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

/**
 * 日期时间转换为时间戳
 * 支持"yyyy-MM-dd HH:mm:ss"格式或"yyyy-MM-dd"格式
 *
 */
export function dateTimeToStamp(dateTimeStr) {
  if (DATE_TIME_REGEXP.test(dateTimeStr) || DATE_REGEXP.test(dateTimeStr)) {
    dateTimeStr = Date.parse(dateTimeStr.replace(/-/g, "/")); //////兼容ie
    let dateTime = new Date(dateTimeStr);
    return dateTime.getTime() / MILLISECOND;
  }
  return "";
}

export function defaultNumber(number = 0) {
  return number
}

export function defaultString(str = '') {
  return str
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

const defaultTreeProps = {
  key: 'id',
  parentKey: 'parentId',
  label: 'label',
  children: 'children',
  rootValue: 0,
  iconKey: 'icon',
  iconValue: '',
  stopKey: 'type',// 停止位
  stopValue: 'sdfadfytuya',// 停止值
};

// 获取树形结构的根节点
export function getTreeRoot(list, treeProps = defaultTreeProps) {
  if (!list) {
    return list;
  }
  treeProps = {...defaultTreeProps, ...treeProps};
  let root = {};
  root[treeProps.key] = treeProps.rootValue;
  root[treeProps.children] = [];
  list.forEach(node => {
    let rootChild;
    if (!node[treeProps.parentKey]) {
      rootChild = node;
    } else if (node[treeProps.parentKey] === treeProps.rootValue) {
      rootChild = node;
    } else {
      let parent = list.find(item => item[treeProps.key] === node[treeProps.parentKey]);
      if (!parent) {
        rootChild = node;
      }
    }
    if (rootChild) {
      let copyNode = {...rootChild};
      root[treeProps.children].push(copyNode);
    }
  });
  return root;
}

// 根据id及parentId创建树形结构
export function buildTree(list, treeProps = defaultTreeProps, root) {
  treeProps = {...defaultTreeProps, ...treeProps};
  if (!root) {
    root = {};
    root[treeProps.key] = treeProps.rootValue;
    root[treeProps.children] = [];
  }
  if (list && list.length > 0) {
    let children = root[treeProps.children];
    list.forEach(node => {
      if (node[treeProps.parentKey] === root[treeProps.key]) {
        if (!children) {
          children = [];
          root[treeProps.children] = children;
        }
        if (!children.find(item => item[treeProps.key] === node[treeProps.key])) {
          let copyNode = {...node};
          // copyNode.parent = root;// 保存父级引用
          children.push(copyNode);
        }
      }
    });
    if (children && children.length > 0) {
      list = list.filter(item1 => !children.some(item2 => item2[treeProps.key] === item1[treeProps.key]));
      children.forEach(node => {
        if (root[treeProps.stopKey] !== treeProps.stopValue) {
          // 递归
          buildTree(list, treeProps, node);
        }
      });
    }
    return root.children;
  } else {
    return root.children;
  }
}

// 根据id和parentId向上遍历，找到自己及其所有的父级
export function getParentList(list, ids, treeProps = defaultTreeProps, resultList = []) {
  treeProps = {...defaultTreeProps, ...treeProps};
  let parentIds = [];
  list.forEach(item => {
    if (ids.indexOf(item[treeProps.key]) >= 0) {
      if (parentIds.indexOf(item[treeProps.parentKey]) < 0) {
        parentIds.push(item[treeProps.parentKey]);
      }
      if (!resultList.some(res => res[treeProps.key] === item[treeProps.key])) {
        let copyNode = {...item};
        let icon = item[treeProps.iconKey];
        copyNode[treeProps.iconKey] = icon ? icon : treeProps.iconValue;
        resultList.push(copyNode);
      }
    }
  });
  if (parentIds.length > 0) {
    // list = list.filter(item1 => !resultList.some(item2 => item2[treeProps.key] === item1[treeProps.key]));
    // 递归
    getParentList(list, parentIds, treeProps, resultList);
  }
  return resultList;
}

// 根据id获取父级id数组,不包含自己的id
export function getParentIds(list, id, treeProps = defaultTreeProps, result = []) {
  treeProps = {...defaultTreeProps, ...treeProps};
  let node = list.find(item => item.id === id);
  if (node && node[treeProps.parentKey] !== treeProps.rootValue) {
    let parentId = node[treeProps.parentKey];
    result.unshift(parentId);
    getParentIds(list, parentId, treeProps, result);
  }
  return result;
}

export function noop() {
}

export function getFileSuffix(filename) {
  let pos = filename.lastIndexOf('.');
  return pos !== -1 ? filename.substring(pos) : '';
}

// 生成文件路径
export function getFilePath(part) {
  let path = "";
  part.forEach((p, i) => {
    if (p) {
      if (path && path.lastIndexOf('/') === path.length - 1) {
        if (p.indexOf('/') === 0) {
          p = p.substring(1)
        }
      } else {
        if (i > 0 && p.indexOf('/') !== 0) {
          p = "/" + p;
        }
      }
      path += p;
    }
  });
  return path;
}

const imageSuffex = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"];

export function isImage(fileName) {
  let suffex = getFileSuffix(fileName);
  return suffex ? imageSuffex.indexOf(suffex.toLocaleLowerCase()) >= 0 : false;
}

export function isPdf(fileName) {
  let suffex = getFileSuffix(fileName);
  return suffex ? suffex.toLocaleLowerCase() === ".pdf" : false;
}

export function saveAsFile(src, name) {
  let b = new Blob([src]);
  let save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
  save_link.href = URL.createObjectURL(b);
  save_link.download = name;
  let ev = document.createEvent("MouseEvents");
  ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  save_link.dispatchEvent(ev);
}

/****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';

export function randomString(len) {
  len = len || 32;
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd;
}

document.write(randomString(32));

export function stringSplit(str, separator = ',') {
  if (str) {
    // TODO 判断str是否为字符串
    try {
      return str.split(",");
    } catch (e) {
      return str
    }
  } else {
    return [];
  }
}
export function debounce(func, delay) {
  let timer

  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}
export const DEFAULT_BUILDING_PIC = '/default/default-building-pic.jpg';
export const DEFAULT_RESCUE_PLAN = '/default/default-rescue-plan.pdf';
